export const SYSTEM_LABELS = {
  salesforce: "Salesforce",
  zoho_crm: "Zoho CRM",
  zoho_books: "Zoho Books",
  oracle_fusion: "Oracle Fusion",
  oracle_netsuite: "Oracle NetSuite",
  oracle_ebs: "Oracle EBS",
};

export const ENV_OPTIONS = [
  { v: "production", l: "Production" },
  { v: "sandbox", l: "Sandbox" },
];

export const DC_OPTIONS = [
  { v: "com", l: ".com (United States)" },
  { v: "eu", l: ".eu (Europe)" },
  { v: "in", l: ".in (India)" },
  { v: "com.au", l: ".com.au (Australia)" },
];

// Per-platform credential form schema (must match backend ORG_SCHEMA).
export const CONFIG = {
  salesforce: {
    method: "credentials",
    submit: "Save org",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "Salesforce org" },
      { key: "environment", label: "Environment", type: "select", options: ENV_OPTIONS },
      { key: "username", label: "Username", type: "text", placeholder: "you@company.com" },
      { key: "password", label: "Password", type: "password", placeholder: "••••••••" },
      { key: "security_token", label: "Security token", hint: "recommended", type: "password", placeholder: "Security token", optional: true },
    ],
    defaults: { environment: "production" },
  },
  zoho_crm: {
    method: "oauth",
    submit: "Connect with Zoho",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "Zoho CRM org" },
      { key: "data_center", label: "Data Center", type: "select", options: DC_OPTIONS },
    ],
    defaults: { data_center: "com" },
  },
  zoho_books: {
    method: "oauth",
    submit: "Connect with Zoho",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "Zoho Books org" },
      { key: "data_center", label: "Data Center", type: "select", options: DC_OPTIONS },
    ],
    defaults: { data_center: "com" },
  },
  oracle_fusion: {
    method: "credentials",
    submit: "Save org",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "Fusion org" },
      { key: "environment", label: "Environment", type: "select", options: ENV_OPTIONS },
      { key: "instance_url", label: "Instance URL", type: "text", placeholder: "https://fa.oraclecloud.com" },
      { key: "username", label: "Username", type: "text", placeholder: "you@company.com" },
      { key: "password", label: "Password", type: "password", placeholder: "••••••••" },
    ],
    defaults: { environment: "production" },
  },
  oracle_ebs: {
    method: "credentials",
    submit: "Save org",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "EBS org" },
      { key: "environment", label: "Environment", type: "select", options: ENV_OPTIONS },
      { key: "instance_url", label: "Instance URL", type: "text", placeholder: "https://ebs.company.com" },
      { key: "username", label: "Username", type: "text", placeholder: "you@company.com" },
      { key: "password", label: "Password", type: "password", placeholder: "••••••••" },
    ],
    defaults: { environment: "production" },
  },
  oracle_netsuite: {
    method: "credentials",
    submit: "Save org",
    fields: [
      { key: "label", label: "Label", type: "text", placeholder: "NetSuite org" },
      { key: "environment", label: "Environment", type: "select", options: ENV_OPTIONS },
      { key: "account_id", label: "Account ID", type: "text", placeholder: "1234567" },
      { key: "consumer_key", label: "Consumer Key", type: "text", placeholder: "Consumer key" },
      { key: "consumer_secret", label: "Consumer Secret", type: "password", placeholder: "••••••••" },
      { key: "token_id", label: "Token ID", type: "text", placeholder: "Token ID" },
      { key: "token_secret", label: "Token Secret", type: "password", placeholder: "••••••••" },
    ],
    defaults: { environment: "production" },
  },
};

export function orgSummary(org) {
  if (!org) return "";
  const parts = [];
  if (org.data_center) parts.push(`.${org.data_center}`);
  if (org.environment) parts.push(org.environment.charAt(0).toUpperCase() + org.environment.slice(1));
  if (org.account_id) parts.push(`Acct ${org.account_id}`);
  if (org.username_masked) parts.push(org.username_masked);
  return parts.join(" · ");
}
